import { render, staticRenderFns } from "./otaUsers.vue?vue&type=template&id=449e441c"
import script from "./otaUsers.vue?vue&type=script&lang=js"
export * from "./otaUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports